module.exports = __webpack_public_path__ + "static/4x_org_onboarding_3-4b931b8d14cbedaadeffd4064ed25fe1.png";